"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devWarnings = require("../utils/devWarnings");

var _Dom = require("../utils/Dom");

var _UIButtonGroup = _interopRequireDefault(require("./UIButtonGroup"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var DefaultContentWrapper = function DefaultContentWrapper(_ref) {
  var children = _ref.children,
      open = _ref.open;

  var onlyChild = children && _react.Children.only(children);

  (0, _devWarnings.warnIfFragment)(onlyChild, 'UIFloatingButtonGroup');
  return _react.default.createElement("div", {
    className: "private-floating-button-group__children"
  }, onlyChild && _react.default.cloneElement(onlyChild, {
    open: open
  }));
};

var maybeRenderButtonsWithClasses = function maybeRenderButtonsWithClasses(buttonGroup, open) {
  if (process.env.NODE_ENV !== 'production') {
    if (buttonGroup.type !== _UIButtonGroup.default) {
      _devLogger.default.warn({
        message: 'UIFloatingButtonGroup: Component in buttonGroup must be a UIButtonGroup component.',
        key: 'UIFloatingButtonGroup: buttonGroup'
      });
    }
  }

  return _react.default.cloneElement(buttonGroup, {
    className: (0, _classnames.default)('private-floating-button-group__buttons', {
      'private-floating-button-group__buttons--hidden': !open
    }, buttonGroup.props.className)
  });
};

var UIFloatingButtonGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIFloatingButtonGroup, _Component);

  function UIFloatingButtonGroup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIFloatingButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIFloatingButtonGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hasFocus: false,
      hasMouseover: false,
      hasMouseoverInTether: false,
      open: false
    };

    _this.handleBlur = function () {
      _this.setState({
        hasFocus: false
      });
    };

    _this.handleFocus = function () {
      _this.setState({
        hasFocus: true
      });
    };

    _this.handleMouseEnter = function () {
      _this.setState({
        hasMouseover: true
      });
    };

    _this.handleMouseMove = function () {
      if (!_this.state.hasMouseover) {
        _this.setState({
          hasMouseover: true
        });
      }
    };

    _this.handleMouseLeave = function (evt) {
      var relatedTarget = evt.relatedTarget;
      var newState = {
        hasMouseover: false
      }; // If the cursor moved into a Tether, watch that Tether until the mouse leaves it.

      var tetherEl = relatedTarget && (0, _Dom.closest)(relatedTarget, '.tether-element');

      if (tetherEl) {
        newState.hasMouseoverInTether = true;

        _this.observeTetherEl(tetherEl);
      }

      _this.setState(newState);
    };

    _this.handleTetherMouseLeave = function (evt) {
      var currentTarget = evt.currentTarget,
          relatedTarget = evt.relatedTarget;
      currentTarget.removeEventListener('mouseleave', _this.handleTetherMouseLeave);

      if (!_this._isMounted) {
        return;
      } // If the cursor moved into another Tether, watch that Tether until the mouse leaves it, too.


      var otherTetherEl = relatedTarget && (0, _Dom.closest)(relatedTarget, '.tether-element');

      if (otherTetherEl) {
        otherTetherEl.addEventListener('mouseleave', _this.handleTetherMouseLeave);
      } else {
        _this.setState({
          hasMouseoverInTether: false
        });
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UIFloatingButtonGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onOpenChange = this.props.onOpenChange;
      var _this$state = this.state,
          hasFocus = _this$state.hasFocus,
          hasMouseover = _this$state.hasMouseover,
          hasMouseoverInTether = _this$state.hasMouseoverInTether; // These state checks prevent infinite update loops when `open` is controlled.

      if (hasFocus !== prevState.hasFocus || hasMouseover !== prevState.hasMouseover || hasMouseoverInTether !== prevState.hasMouseoverInTether) {
        var shouldBeOpen = hasFocus || hasMouseover || hasMouseoverInTether;
        onOpenChange((0, _SyntheticEvent.default)(shouldBeOpen));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "observeTetherEl",
    value: function observeTetherEl(tetherEl) {
      var _this2 = this;

      tetherEl.addEventListener('mouseleave', this.handleTetherMouseLeave);
      this._observer = new MutationObserver(function () {
        if (!document.body.contains(tetherEl)) {
          _this2.handleTetherRemoved(tetherEl);
        }
      });

      this._observer.observe(tetherEl, {
        childList: true
      });
    }
  }, {
    key: "handleTetherRemoved",
    value: function handleTetherRemoved(elem) {
      if (!this._observer) {
        return;
      }

      this._observer.disconnect();

      this._observer = null;
      elem.removeEventListener('mouseleave', this.handleTetherMouseLeave);

      if (!this._isMounted) {
        return;
      }

      this.setState({
        hasMouseoverInTether: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          buttonGroup = _this$props.buttonGroup,
          children = _this$props.children,
          className = _this$props.className,
          ContentWrapper = _this$props.ContentWrapper,
          __onOpenChange = _this$props.onOpenChange,
          open = _this$props.open,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["buttonGroup", "children", "className", "ContentWrapper", "onOpenChange", "open"]);
      return _react.default.createElement("div", Object.assign({}, rest, {
        className: (0, _classnames.default)(className, 'private-floating-button__group'),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }), maybeRenderButtonsWithClasses(buttonGroup, open), _react.default.createElement(ContentWrapper, {
        open: open
      }, children));
    }
  }]);
  return UIFloatingButtonGroup;
}(_react.Component);

UIFloatingButtonGroup.propTypes = {
  children: _propTypes.default.node,
  ContentWrapper: _propTypes.default.elementType,
  buttonGroup: _propTypes.default.node.isRequired,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool
};
UIFloatingButtonGroup.defaultProps = {
  ContentWrapper: DefaultContentWrapper
};
UIFloatingButtonGroup.displayName = 'UIFloatingButtonGroup';

var _default = (0, _Controllable.default)(UIFloatingButtonGroup, ['open']);

exports.default = _default;
module.exports = exports.default;